module.exports = __webpack_public_path__ + "static/media/settings.41141a51.svg";